import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { STAFF } from "@/shared/resource/apis/endpoints";

export const useStaffStore = defineStore("staff", {
  actions: {
    async addStaff(payload) {
      const response = await api.post(STAFF.POST, payload);
      return response.data;
    },
    async deleteStaff(id) {
      const response = await api.delete(STAFF.DELETE(id));
      return response.data;
    },
    async updateStaff(id, payload) {
      const response = await api.put(STAFF.UPDATE(id), payload);
      return response.data;
    },
  },
});
